// extracted by mini-css-extract-plugin
module.exports = {"actions":"ProductDisclaimer_actions__2P_JZ","link":"ProductDisclaimer_link__2tdyO","action":"ProductDisclaimer_action__19tRD"};